/*****  *****/
const KEYS_USER_ANYA = [
  'key',
  'name',
  'lastName',
  'role',
  'token',
  'intents',
  'lastConexion'
];

export const storeUser = (values) => {
  try {
    KEYS_USER_ANYA.forEach((key) => {
      if (values[key]) {
        localStorage.setItem(key, String(values[key]));
      }
    });
    return true;
  } catch (err) {
    return err;
  }
};

export const storeToken = (newToken) => {
  try {
    localStorage.setItem('token', String(newToken));
    return true;
  } catch (err) {
    return err;
  }
};

export const getUser = () => {
  const userData = {};
  KEYS_USER_ANYA.forEach((key) => {
    userData[key] = localStorage.getItem(key); // Obteniendo los datos del localStorage
  });
  return userData;
};

export const clearUser = () => {
  KEYS_USER_ANYA.forEach((key) => {
    localStorage.removeItem(key);
  });
};

/*****  *****/

const KEYS_STUDENT = [
    'names',
    'lastnames',
    'email',
    'plan',
    'payment'
];

export const storeStudent = (values) => {
    try {
      KEYS_STUDENT.forEach((key) => {
        if (values[key]) {
          localStorage.setItem(key, String(values[key]));
        }
      });
      return true;
    } catch (err) {
      return err;
    }
};

export const getStudent = () => {
  const studentData = {};
  KEYS_STUDENT.forEach((key) => {
    studentData[key] = localStorage.getItem(key); // Obteniendo los datos del localStorage
  });
  return studentData;
};

export const clearStudent = () => {
  KEYS_STUDENT.forEach((key) => {
    localStorage.removeItem(key);
  });
};
